import ProgressiveVideoPreview from '@anm/components/video/ProgressiveVideoPreview';
import getDateDay from '@anm/helpers/date/getDateDay';
import useHover from '@anm/hooks/useHover';
import { FC } from 'react';

import { DateBudge, DateCell, DayCell, ItemCard, ItemTitle, ItemWrapper } from './Wrapper';
import { getMediaProps } from './helpers';
import { CalendarItemProps } from './types';

const CalendarItem: FC<CalendarItemProps> = ({ size, date, title, preview }) => {
  const [ref, isHovered] = useHover<HTMLDivElement>();

  const [dateVal, dayVal] = getDateDay(date);
  const [mediaProps, isVerticalVideo] = getMediaProps(preview);

  return (
    <ItemWrapper>
      <ItemCard {...{ size, ref, isVerticalVideo }}>
        <ProgressiveVideoPreview
          alt={title.toString()}
          width={size}
          height={size}
          // isFirstRenderPreview
          {...{ isHovered, ...mediaProps }}
        />
        <DateBudge>
          <DateCell>{dateVal}</DateCell>
          <DayCell>{dayVal}</DayCell>
        </DateBudge>
      </ItemCard>
      <ItemTitle>{title}</ItemTitle>
    </ItemWrapper>
  );
};

export default CalendarItem;
